/* React view of the vision lane (lib/vision-lane.ts): the current lane,
 * re-rendering on a switch made here or in another window. */
import React from 'react';
import { getVisionLane, onVisionLane, type VisionLane } from './vision-lane';

export function useVisionLane(): VisionLane {
  return React.useSyncExternalStore(onVisionLane, getVisionLane);
}
